import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { ElectionCountdown } from "../components/ElectionCountdown";
import { HomeHero } from "../components/HomeHero";
import { HomeOverview } from "../components/HomeOverview";
import { HomeGalleryCarousel } from "../components/HomeGalleryCarousel";
import { AvatarBanner } from "../components/AvatarBanner";
import { Reveal } from "../components/Reveal";

export function HomePage() {
  return (
    <>
      <HomeHero />
      <ElectionCountdown />
      <HomeOverview />

      <section className="home-gallery">
        <div className="shell">
          <Reveal className="section-heading">
            <h2>Palmas em movimento.</h2>
            <p>
              Registros de obras, equipamentos e espaços apresentados pela
              assessoria.
            </p>
          </Reveal>
          <Reveal>
            <HomeGalleryCarousel />
            <Link className="text-link gallery-link" to="/galeria">
              Ver todos os registros <ArrowUpRight size={19} />
            </Link>
          </Reveal>
        </div>
      </section>

      <AvatarBanner />

    </>
  );
}
